export const types = {
    CONNECT: 'CONNECT',
    RUNCOMMAND: 'RUN-COMMAND',
    INPUT: 'INPUT',
    DISCONNECT: 'DISCONNECT'
};